<template>
  <div v-if="user" class="item-with-submenu">
    <a class="button submenu-trigger">
      <img :alt="user.displayName" :src="user.photoURL" class="user-photo" v-if="user.photoURL">
      <span v-else>{{ user.displayName }}</span>
    </a>
    <div class="submenu">
      <router-link class="button" @click="closeSubmenus" to="/artworks">Artworks</router-link>
      <router-link class="button" @click="closeSubmenus" to="/account/artists">Artists</router-link>
      <div class="sub-section">
        <router-link class="button" @click="closeSubmenus" to="/account/players">Players</router-link>
        <router-link class="button" @click="closeSubmenus" to="/account/update">Team profile</router-link>
        <router-link class="button" @click="closeSubmenus" to="/user/update">Your profile</router-link>
        <router-link class="button" @click="closeSubmenus" to="/account/invitations">Invitations</router-link>
        <router-link class="button" @click="closeSubmenus" to="/logout">Logout</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import SubmenuMixin from '../../../mixins/submenu'

export default {
  name: 'HeaderUserMenu',
  props: {
    user: { type: Object, required: true }
  },
  mixins: [SubmenuMixin('submenu', 'submenu-trigger')]
}
</script>
